<template>
	<div>
		<div class="user_auth" v-if="cur_step == 'auth'">
			<form class="user">
				<div class="form-group">
					<b-form-input
						@animationstart="checkAnimation"
						ref="email"  :state="username_state" id="input-live-feedback" v-model="user_form.username" class="form-control form-control-user" placeholder="USER"></b-form-input>
					<b-form-invalid-feedback id="input-live-feedback">
                        {{__t('MIN_USER')}}
					</b-form-invalid-feedback>

				</div>
				<div class="form-group">
					<b-form-input   :state="userpass_state" id="user_pass" type="password" v-model="user_form.password" class="form-control form-control-user" placeholder="Password"></b-form-input>

					<b-form-invalid-feedback id="user_pass">
                        {{__t('MIN_PASS')}}
					</b-form-invalid-feedback>

				</div>
				<div class="form-group">
					<b-button :disabled="!is_disabled" class="btn btn-warning btn-user btn-block" v-on:click="make_auth">
                        {{__t('LOGIN')}}
                    </b-button>
				</div>
                <!--
                <div id="anim">
                    <vue-particles    :particlesNumber="80" color="#dedede"></vue-particles>
                </div>
                -->
				<!--
				<div class="form-group">
					<b-button class="btn btn-danger btn-user btn-block" v-on:click="go_register">Регистрация</b-button>
				</div>
				-->
			</form>
		</div>
	</div>
</template>


<script>
    import Register from "./register/register";
	export default {
		components: {Register},
		data() {
            return {
                is_auth : false,
				autofilled : false,
				cur_step : "auth",
                user_form : {
                    username : "",
                    password : "",
                    api_auth : true,
                }
            }
        },

		mounted () {
			this.$refs.email.focus();
			_core.hideloading();
		},

        created() {
			_core.showloading();
			//this.$refs.email.focus()
        },

        methods: {
			checkAnimation(e) {
				if(e.animationName == "onAutoFillStart")
				{
					this.autofilled = true;
				}
				else if(e.animationName == "onAutoFillCancel")
				{
					this.autofilled = false;
				}
			},
			go_register() {
				this.cur_step = 'register';
				//EventBus.$emit('show_toast', {err: "https://getorder.biz/contact/", type: "danger", title: "По вопросам регистрации "})
			},

            async make_auth () {
                _core.showloading();
                await api.post('/user_auth', this.user_form).then(({data}) => {
                    _core.hideloading();
                    if (data.status === "operation_success") {

                        if(data.data.hasOwnProperty("redirect")) {
                            window.location.href = data.data.redirect;
                        }
                        else {
                            window.location.reload();
                        }
                    } else {
                        EventBus.$emit('show_toast', {err: "Ошибка Авторизации", type: "danger", title: "Нет"})
                    }
                }).catch((error) => {
                    _core.hideloading();
                    if (error.hasOwnProperty("response")) {
                        let resp = error.response.data;
                        EventBus.$emit('show_toast', {err: resp.message, type: "danger", title: resp.status})
                    } else {
                        EventBus.$emit('show_toast', {err: "Ошибка Авторизации", type: "danger", title: "Ошибка"})
                    }
                })
            },
        },

        computed : {

            is_disabled () {
                return this.username_state && this.userpass_state;
            },

            username_state() {
                return this.user_form.username.length > 2;
            },

            userpass_state () {
                return this.user_form.password.length > 5;
            }
        }
    }
</script>

<style scoped>

</style>
